import VueI18n from 'vue-i18n'
import Vue from 'vue'
import messages from './messages'

// onboarding translations
Vue.use(VueI18n)

// Create VueI18n instance with options
export default new VueI18n({
  locale: localStorage.getItem('locale'), // set locale
  fallbackLocale: 'en_US',
  messages,
  silentFallbackWarn: true, // Suppress fallback warnings
  silentTranslationWarn: true // Suppress missing translation warnings
})